import {defineStore} from 'pinia'
import {uuid} from 'vue-uuid'

interface CustomerImage {
  uuid: string;
  widgetId: string;
  url: string;
  notes: string|null;
}

export interface CustomerState {
  customerImages: CustomerImage[],
  chosenDropdownValue: {},
  chatHistories: {}
}

export const useCustomerStore = defineStore('customerStore', {
  state: (): CustomerState => ({
    customerImages: [],
    chosenDropdownValue: {},
    chatHistories: {}
  }),

  actions: {
    setUpImage(widgetId: string, notes: string|null = null) {
      const imageExists = this.customerImages.some((image) => image.widgetId === widgetId)
      if (imageExists) return

      if (!notes) notes = 'Button'

      const newImage: CustomerImage = {
        uuid: uuid.v4(),
        widgetId: widgetId,
        url: '',
        notes: notes
      }
      this.customerImages.push(newImage)
    },

    removeImage(widgetId: string) {
      const index = this.customerImages.findIndex((image) => image.widgetId === widgetId)
      if (index !== -1) {
        this.customerImages.splice(index, 1)
      }
    },

    updateImage(widgetId: string, updates: Partial<CustomerImage>) {
      const image = this.customerImages.find((image) => image.widgetId === widgetId);
      if (image) {
        Object.assign(image, updates);
      }
    },

    addMessage(elementId: string, userPrompt: string, modelResponse: string) {
      if (!this.chatHistories[elementId]) {
        this.chatHistories[elementId] = []
      }
      this.chatHistories[elementId].push({ user: userPrompt, model: modelResponse })
    },

    getChatHistory(elementId: string) {
      return this.chatHistories[elementId] || []
    }
  }
})
